import React, { useEffect, useState } from "react";
import { useDraftOrders } from "queries/transactions";
import SimpleTable from "modules/Tables/SimpleTable";
import { deleteHeader, loadingObj } from "helpers/transactions";
import Heading from "@hubins/components/Heading";
import { __ } from "localisation";
import Button from "@hubins/components/Button";
import { getMoney } from "helpers";
import BackofficePortfolioLink from "@hubins/components/BackofficePortfolioLink/BackofficePortfolioLink";
import BackofficeProfileLink from "@hubins/components/BackofficeProfileLink";

const loadingState = [loadingObj, loadingObj];

type Step1Props = {
  portfolioUuid: string | undefined;
  setSelectedTransaction: (transaction: object) => void;
  setCreateNew: (createNew: boolean) => void;
};

const Step1 = ({
  portfolioUuid,
  setSelectedTransaction,
  setCreateNew,
}: Step1Props) => {
  const [formattedTransactions, setFormattedTransactions] = useState<object[]>(
    [],
  );
  const {
    data: transactions,
    isLoading,
    isFetched,
    refetch,
  } = useDraftOrders(portfolioUuid);

  const headers = [
    {
      Header: "",
      accessor: "open",
    },
    deleteHeader(refetch),
    {
      Header: __("policy_holder"),
      accessor: "portfolio.policy_holder",
      Cell: ({ value, row }) => {
        if (value) {
          if (Array.isArray(value)) {
            return value.map((item: any, index: number) => {
              return (
                <>
                  <BackofficeProfileLink
                    key={item.uuid}
                    profileUuid={item.uuid}
                  >
                    {item.name}
                  </BackofficeProfileLink>
                  {index < value.length - 1 && <br />}
                </>
              );
            });
          } else {
            return value;
          }
        } else {
          return "";
        }
      },
    },
    {
      Header: __("portfolio"),
      accessor: "portfolio.short_name",
      Cell: ({ row }) => (
        <>
          {row?.original?.portfolio?.short_name && (
            <BackofficePortfolioLink
              portfolioUuid={row?.original?.portfolio_uuid}
              // profileUuid={row?.original?.uuid}
            >
              {row?.original?.portfolio?.short_name}
            </BackofficePortfolioLink>
          )}
        </>
      ),
    },
    {
      Header: __("initial_trade_amount"),
      accessor: "amount",
      Cell: ({ value }) => (value ? getMoney(value / 100) : ""),
    },
    {
      Header: __("security"),
      accessor: "security.name",
    },
    {
      Header: __("units"),
      accessor: "units",
    },
    {
      Header: __("trade_origin"),
      accessor: "origin",
    },
    {
      Header: __("trade_origin_account"),
      accessor: "origin_account",
    },
    {
      Header: __("type"),
      accessor: "type",
      Cell: ({ value }) =>
        typeof value === "string" ? __("transaction_type_" + value) : value,
    },
    {
      Header: __("status"),
      accessor: "status",
    },
  ];

  useEffect(() => {
    if (transactions) {
      setFormattedTransactions(
        transactions.map((transaction: object) => ({
          ...transaction,
          open: (
            <Button onClick={() => setSelectedTransaction(transaction)}>
              {__("continue")}
            </Button>
          ),
        })),
      );
    }
  }, [transactions]);

  return (
    <div>
      <Button
        onClick={() => setCreateNew(true)}
        className="s-top-xl"
        icon="add"
      >
        {__("create_new_entry")}
      </Button>
      <Heading size={4} className="s-top-xl s-bottom-m">
        {__("draft_transactions")}
      </Heading>
      <SimpleTable
        headers={headers}
        data={isLoading || !isFetched ? loadingState : formattedTransactions}
      />
    </div>
  );
};

export default Step1;
